type Props = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  dark
}: Props) {
  return <div className="mx-auto max-w-2xl text-center" data-id="element-207" data-mp="3tw9z7131islq">
      {eyebrow && <span className={`inline-block rounded-full px-3 py-1 text-xs font-700 uppercase tracking-wider ${dark ? "bg-white/10 text-[#8ec9ff]" : "bg-[#1e88e5]/10 text-[#1e88e5]"}`} data-id="element-208" data-mp="3f2n8a1dv6ysl">
          {eyebrow}
        </span>}
      <h2 className={`mt-3 font-head text-2xl font-800 leading-tight sm:text-3xl lg:text-4xl ${dark ? "text-white" : "text-[#0f2547]"}`} data-id="element-209" data-mp="gix2hgsgaua3">
        {title}
      </h2>
      {subtitle && <p className={`mx-auto mt-3 max-w-xl text-sm leading-relaxed sm:text-base ${dark ? "text-white/65" : "text-slate-500"}`} data-id="element-210" data-mp="6rk8ojn3du1f">
          {subtitle}
        </p>}
    </div>;
}